import { Config } from "../types/config";

export type { Config };

const config: Config = {
  AppName: "CADViewer: CADViewer Public Demo ", //"CADViewer: Visual Query  ", //"License Keys: CADViewer Conversion Server / TailorMade REST-API Conversion Server", //"Tenants Overview Plans - Current Floor-plan", //"Standard Visual Query encapsulation of CADViewer", //"Tenants Overview Plans - Current Floor-plan", //"Standard Visual Query encapsulation of CADViewer", // "Comparez les dessins d'infrastructures ferroviaires", // BPRetail "Tenants Overview Plans - Current Floor-plan",   //  "CADViewer: Visual Query ",     // Tenants Overview Plans  &nbsp;&nbsp;- &nbsp;&nbsp;Current Floor-plan:
  ContactEmailsFlag: true, // set to true to display contact emails in the about box
  ContactEmails: [
    "developer@tailormade.com",
    "internationalsales@tailormade.com",
  ],
  ZoomFactor: 25.0, // zoom factor for cvjs_zoomHere_ObjectId() in left panel click
  ServerBackEndUrl: "https://server.demo.cadviewer.com", //"http://localhost:3000", // This is the URL of the CADViewer back-end server
  analyticsApiUrl: "https://analytic.cadviewer.com",
  ServerLocation: "", // leave blank  in most cases
  ServerUrl: "https://demo.cadviewer.com", //"http://localhost:3001", // this is the URL of the front end server
  postFixServerToken: false, // true if the server shall be contatenated with a Token, kept on the Server, use a postfixed SAS token, when loading JSON content
  bearerToken: "", //"Bearer t-7614f875-8423-4f20-a674-d7cf3096290e", // security bearer token (if not applicable, set to "")

  debugMode: true, // enables CADViewer debug traces in the browser

  setCADViewerLanguage: "English", // Available languages:  "English" ; "French, "Korean", "Spanish", "Portuguese", "Chinese-Simplified", "Chinese-Traditional"

  initFileName: "/content/demo_user/1st floor architectural_01.dwg", //"/content/custom/bpretail/bpretail-splash-05.svg", // the initialization drawing when loading Visual Query, based on a server path
  // "initFileName":"", // initial drawing to load, if empty, no drawing is loaded

  canvasMode: "SINGLE", // SINGLE || MULTIPLE

  UploadNewFile: "Upload file(s) to: MY FOLDER/GLOBAL FOLDER", //""Upload new file", // text for upload new file button

  activateCompareOnLoad: false,
  // false is default,  activate the compare tool on load  example call: http://localhost:3001/?compareFile=/nodejs/cadviewer-conversion-server/content/drawings/dwg_compare_drawings/hq17-1.dwg&compareWith=/nodejs/cadviewer-conversion-server/content/drawings/dwg_compare_drawings/hq17-2.dwg

  // cadviewer license key
  cadviewerLicenseKey: "00110101",

  // conversion parameters - these can dynamically be change in the settings modal
  conversionParameters: [
    { param: "last", value: "" },
    { param: "extents", value: "" },
    { param: "rl", value: "RM_" },
    { param: "tl", value: "RM_TXT" },
    { param: "ial", value: "" },
  ],

  setBPLayerChange: true, // SET custom HEADER for BP Retail Layer Change  - 10.55.2
  defaultLayerColorsOnLoad: [
    // set the layer colors for BP Retail
    { layer: "0", color: "#000" },
    { layer: "ARCH-DOORS-EXTERIOR", color: "#000" },
    { layer: "ARCH-DOORS-INTERIOR", color: "#000" },
    { layer: "ARCH-FEATURES", color: "#000" },
    { layer: "ARCH-OPENINGS-ABOVE", color: "#000" },
    { layer: "ARCH-OPENINGS-BELOW", color: "#000" },
    { layer: "ARCH-SITE-MISCELLANEOUS", color: "#000" },
    { layer: "ARCH-SYMBOLS", color: "#000" },
    { layer: "ARCH-WALLS-EXTERIOR", color: "#000" },
    { layer: "ARCH-WALLS-INTERIOR", color: "#000" },
    { layer: "BD-STORAGE", color: "#000" },
    { layer: "TABLE-ACREAGE", color: "#000" },
    { layer: "SITE-BUILDING", color: "#000" },
    { layer: "SITE-CURB", color: "#000" },
    { layer: "SITE-PARKING", color: "#000" },
    { layer: "TABLE-PARKING-DATA", color: "#000" },
    { layer: "SITE-PROPERTY-LINE", color: "#000" },
    { layer: "SITE-SIDEWALK", color: "#000" },
    { layer: "SITE-MISCELLANEOUS", color: "#000" },
    { layer: "SITE-STRIPING", color: "#000" },
    { layer: "SITE-TEXT", color: "#000" },
    { layer: "DIMENSIONS-STRUCTURAL-GRID", color: "#000" },
    { layer: "DIMENSIONS-TENANT", color: "#000" },
    { layer: "STRUCTURAL-EXPANSION-JOINT", color: "#000" },
    { layer: "KIOSK-SF", color: "#000" },
    { layer: "TENANT-SPNO", color: "#000" },
    { layer: "TENANT-SF", color: "#000" },
    { layer: "KIOSK-NAME", color: "#000" },
    { layer: "TENANT-OCCUPANCY-COST", color: "#000" },
    { layer: "TENANT-R12-SALES", color: "#000" },
    { layer: "TENANT-NAME", color: "#000" },
    { layer: "STRUCTURAL-SHEAR-WALL", color: "#000" },
    { layer: "STRUCTURAL-BRACING", color: "#000" },
    { layer: "STRUCTURAL-COLUMNS", color: "#000" },
    { layer: "STRUCTURAL-GRID-TAGS", color: "#000" },
    { layer: "ARCH-WALLS-DEMISING", color: "#000" },
    { layer: "TENANT-STOREFRONT-LEASELINE", color: "#000" },
    { layer: "TEXT-GENERAL", color: "#000" },
    { layer: "TEXT-MISCELLANOUS", color: "#000" },
    { layer: "TEXT-NOTES", color: "#000" },
    { layer: "TITLEBLOCK", color: "#000" },
    { layer: "UTILITIES-ELECTRICAL", color: "#000" },
    { layer: "UTILITIES-EQUIPMENT", color: "#000" },
    { layer: "UTILITIES-HVAC", color: "#000" },
    { layer: "UTILITIES-PLUMBING", color: "#000" },
    { layer: "KIOSK-SPNO", color: "#000" },
    { layer: "XREF", color: "#000" },
    { layer: "ARCH-CORPORATE-OFFICE-EQUIPMENT", color: "#000" },
    { layer: "ARCH-CORPORATE-OFFICE-GLAZING", color: "#000" },
    { layer: "FURNITURE-CORPORATE-OFFICE-BLACK", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-CONFERENCE-ROOM-PL", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-ENCLAVE-PL", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-STORAGE-PL", color: "#000" },
    { layer: "TEXT-CORPORATE-OFFICE-FLOOR-IDENTIFICATION", color: "#000" },
  ],

  defaultLayerSetTimeout: 50, // in milliseconds
  currentView: [], // placeholder for the current view, set by the view menu

  // VISUAL QUERY PANEL CONTROLS
  ShowInformativeBottomPanel: false, // turn the the bottom panel on off
  ShowInformativeBottomPanelWhenClickInLeftPanel: true,
  ShowInformativeLeftPanel: false, // initia show the left side panel
  bottomPaneSliderMode: "withCADViewer", // withCADViewer, aboveCADViewer,
  bottomPaneDefaultHeight: 15, // (15)   percentage of screen height (2) min
  rightPanelDefaultWidth: 36, // (40) percentage of screen height
  leftPaneDefaultWidth: 17, // (17) percentage of screen height

  // print pdf controls
  printPDFflag: false, // add/remove checkbox for print as pdf
  printAsPDF: false, // force server side conversion to pdf
  setPaperSize: "letter", // "A4"  , "letter"    set the papersize on the print modal
  // printer controls
  printMargins_nonprint_h: 10, // non print margin region vertical, default 10mm
  printMargins_nonprint_w: 10, // non print margin region horizontal, default 10mm
  printMargins_standard_h: 18, // non print margin region horizontal, default 18mm
  printMargins_standard_w: 8, // non print margin region vertical, default 8mm
  printMargins_tiny_h: 10, // non print margin region horizontal, default 6mm
  printMargins_tiny_w: 6, // non print margin region vertical, default 6mm
  printMargins_none_h: 0, // no margins, default 0mm
  printMargins_none_w: 0, // no margins, default 0mm

  // controls for print as pdf from svg for highresolution pdf generation
  pdfReportsAsSVG: true,
  printAsPDFfromSVG: true, 



  // CADVIEWER MENU CONTROLS
  DisplayCoordinatesMenu: false, // display the CADViewer coordinates menu
  displayTopNavigationBar: false, // display the layout /model space navigation menu
  setSpaceObjectsCustomMenu: false, // display the SpaceObject Navigation menu
  hideLeftHamburgerMenu: true, // hide the left hamburger menu

  // TOP NAVIGATION BAR CONTROLS
  displayTopMenuIconBar: true, // display the top menu icon bar
  setTopMenuXMLDirect: true, //true          // determines if XML menu is loaded from file or passed over from sting expression
  // controls for loading top icon menu from server
  topMenuXML: "cadviewer_full_commands_01.xml", //"cadviewer_minimum_viewonly_svg_02.xml",        // menu configuration file used  - default is: cadviewer_full_commands_01.xml   cadviewer_viewonly_nofileload_01.xml
  topMenuXMLpath: "/cadviewer/app/cv/cv-pro/menu_config/", //  the path for XML config files no nodejs conversion server

  // zoom controls for bitmap wallpaper
  setZoomImageWallpaper: false, // set the zoom image wallpaper
  setZoomImageWallpaper_scalefactor: 1.0, // set the zoom image wallpaper scale factor , fixed at 1.0
  setZoomImageWallpaper_scalebreakpoint: 0.3, // set the zoom image wallpaper switch breakpoint

  // control og mouse wheel operations
  setScrollWheelThrottleDelay: 200, // millisec scroll throttle delta
  setScrollWheelZoomSteps: 0, // zoom steps, omit zoom wheel interaction,
  setScrollWheelDefaultZoomFactor: 1.2, // default zoom factor for scroll wheel

  // fixed line weight controls
  setNormalizeFixedLineWeights: false, // adjust fixed line weights
  setNormalizeFixedLineWeightsFactor: 2, // global scale factor for fixed line weights

  // FOR DEMO MODE WE PREVENT SAVE OF REDLINES, SPACE OBJECTS AND IMAGE LINKS

  topMenuXML_config_file: `
    <cvjs>
    <iconmenu>
        <totalpages>1</totalpages>
        <startpage>1</startpage>
        <pages>
            <page>
                <command>cvjs_Print</command>
                <command>cvjs_LayerList</command>
                <command>cvjs_toggleBlackWhite</command>
                <command>cvjs_setBackgroundColor</command>
                <command>cvjs_interactiveSearchText</command>
                <command>cvjs_Measurement</command>
                <command>cvjs_calibrateMeasurement</command>
                <command>cvjs_displayMagnifyingGlass</command>
                <command>cvjs_activateLineThicknessModal</command>
                <command>cvjs_setRedlineColor</command>
                <command>cvjs_setRedlineThickness</command>
                <command>cvjs_drawStickyNote</command>
                <command>cvjs_drawRedlineText</command>
                <command>cvjs_drawRedline_Freehand</command>
                <command>cvjs_drawRedlineEllipseCloud</command>
                <command>cvjs_drawRedlineFilledPolygon</command>
                <command>cvjs_drawRedlinePolyline</command>
                <command>cvjs_drawRedlineFilledRectangle</command>
                <command>cvjs_drawRedlineRectangle</command>
                <command>cvjs_drawRedlineArrow</command>
                <command>cvjs_deleteSingleRedline</command>
                <command>cvjs_deleteLastRedline</command>
                <command>cvjs_clearCurrentRedline</command>
                <command>cvjs_adjustRedlinePoints</command>
                <command>cvjs_About</command>
                <command>cvjs_Settings</command>
                <command>cvjs_Help</command>
            </page>
            <page>
                <command>cvjs_customCommand_19</command>
                <command>cvjs_loadSpaceObjectsUser</command>
                <command>cvjs_customCommand_12</command>
                <command>cvjs_saveAsSVGOnServer</command>
                <command>cvjs_changeSpaceObjectDisplayMode</command>
                <command>cvjs_addPolygonSpaceObject</command>
                <command>cvjs_addRectangleSpaceObject</command>
                <command>cvjs_addCircleSpaceObject</command>
                <command>cvjs_copyCircleSpaceObject</command>
                <command>cvjs_resizeSpaceObject</command>
                <command>cvjs_moveSpaceObject</command>
                <command>cvjs_rotateSpaceObject</command>
                <command>cvjs_deleteSpaceObject</command>
                <command>cvjs_clearSpaceObjects</command>
                <command>cvjs_adjustSpaceObjectPoints</command>
                <command>cvjs_bringToFront</command>
                <command>cvjs_sendToBack</command>
                <command>cvjs_bringForward</command>
                <command>cvjs_sendBackward</command>
                <command>cvjs_insertImageLink</command>
                <command>cvjs_loadAllImageLinks</command>
                <command>cvjs_customCommand_11</command>
                <command>cvjs_clearAllImageLinks</command>
                <command>cvjs_quickCount</command>
                <command>cvjs_showMeCounts</command>
                <command>cvjs_clearQuickCounts</command>
                <command>cvjs_LayerListSpace</command>
                <command>cvjs_swapLayersInDrawing</command>
                <command>cvjs_allLayersInDrawingOn</command>
                <command>cvjs_About</command>
                <command>cvjs_Settings</command>
                <command>cvjs_Help</command>
            </page>
            </pages>
            <icons_per_row>0</icons_per_row>
            <icon_page_left_x>0</icon_page_left_x>
            <icon_page_left_y>0</icon_page_left_y>
            <customcommand>
                <tooltip>Command tooltip 1</tooltip>
                <tooltip>Command tooltip 2</tooltip>
                <tooltip>Command tooltip 3</tooltip>
                <tooltip>Command tooltip 4</tooltip>
                <tooltip>Command tooltip 5</tooltip>
                <tooltip>Command tooltip 6</tooltip>
                <tooltip>Command tooltip 7</tooltip>
                <tooltip>Command tooltip 8</tooltip>
                <tooltip>Command tooltip 9</tooltip>
                <tooltip>Command tooltip 10</tooltip>
                <tooltip>Command tooltip 11</tooltip>
                <tooltip>Command tooltip 12</tooltip>
                <tooltip>Command tooltip 13</tooltip>
                <tooltip>Command tooltip 14</tooltip>
                <tooltip>Command tooltip 15</tooltip>
                <tooltip>Command tooltip 16</tooltip>
                <tooltip>Command tooltip 17</tooltip>
                <tooltip>Command tooltip 18</tooltip>
                <tooltip>Command tooltip 19</tooltip>
                <tooltip>Select Property</tooltip>
            </customcommand>	
        </iconmenu>
        <zoommenu>
            <location_left_x>2</location_left_x>
            <location_left_y>40</location_left_y>
        </zoommenu>
        </cvjs>
        `,
  customSpriteCommands: [
    {
      commandName: "cvjs_customCommand_19",   // browse file folder
      spriteId: "fileload",
    },
    {
      commandName: "cvjs_customCommand_18",
      spriteId: "fileload",
    },
    {
      commandName: "cvjs_customCommand_12",
      spriteId: "savespaceobjects",     // save space objects
    },
    {
      commandName: "cvjs_customCommand_11",   // save image links
      spriteId: "saveallimagelinks",
    },
    {
      commandName: "cvjs_customCommand_10",    // redline save
      spriteId: "floppyredlines",
    }
  ],
  setUnitForCalibrate: "feet", // set base unit for calibrate modal
  // DRAWING BASE LINE WEIGHT
  adjustMinimumLineThickness: 100, // Line minimum thickness, in percentage of the minimum line weight in the loaded drawing

  setNoModalMode: false, // set no highlight modal mode to true or false

  CADViewerPublicDemo: false, // set the CADViewerPublicDemo to true or false

  // SETTINGS OF THE COLORS OF SPACES  - blue base colors
  BaseAttributes: {
    fill: "#ffffff",
    "fill-opacity": "0.0",
    stroke: "#CCC",
    "stroke-width": 0,
    "stroke-linejoin": "round",
    "stroke-opacity": "0.0",
  },

  HighlightAttributes: {
    fill: "ffffff",
    "fill-opacity": "0.0",
    stroke: "#ffd7f4",
    "stroke-width": 0,
    "stroke-linejoin": "round",
    "stroke-opacity": "0.0",
  },

  SelectAttributes: {
    fill: "#ffffff",
    "fill-opacity": "0.0",
    stroke: "#3E20E7",
    "stroke-width": 1,
    "stroke-linejoin": "round",
    "stroke-opacity": "0.8",
  },
  setSpaceNameAsTypeInPopup: false, // set space name as type in popup to true or false

  setRedlineModeInfo: false, // set redline mode info to true or false
  setRedlineDynamicPath: true, // set redline dynamic path to true or false , this will ensure one redline location per drawing
  setSpaceObjectDynamicPath: true, // set space object dynamic path to true or false , this will ensure one space object location per drawing
  setImageObjectDynamicPath: true, // set imageobject dynamic path to true or false , this will ensure one image object location per drawing

  setCADViewerSkin: "black", //CADViewer Skin light-skin, dark.skin, lightgray, black, deepblue

  // enable or disable top bar features
  enableLoginFeature: true, // SET THE logon interface for users
  // enable or disable features in ... right side icon
  rightMenuMode: "Inline", // Popup, Inline
  rightMenuPopupText: "Open Menu",
  enableRightMenuIcon: true,
  enableRightFileModalPanel: true,
  enableRightFileModalPanelVersionControl: true,
  rightFileModalPanelVersionDisplay: ["dwg", "svg", "dxf", "json"],
  enableRightFileModalPanelText: "Folder Structure", //"Dateiordnerstruktur", //"Structure des dossiers", //"Folder Structure",   //
  enableSpaceInfoCopyButtonTopControl: false,
  enableSpaceInfoCopyButtonTopControlText: "Toggle Data Import",
  rightFileModalPanelTitle: "Folder Structure", //"Dateiordnerstruktur", //"Structure des dossiers", //"Folder Structure",   //
  rightFileModalPanelSubTitle: "Drill down to select file", //"Explorez pour sélectionner le fichier", //"Drill down to select file",

  enableRightEmployeePanel: false,
  enableRightEmployeePanelText: "Employees",
  enableRightArchivePanel: false,
  enableRightArchivePanelText: "Archive",

  layerOptionWidth: 460, // in pixels
  rightActionPanelWidth: 600, //Todo in pixels
  planFile: "plan.json",
  planTypeText: "Plan",
  planSubTypeText: "Type",

  // controls for redline text
  setforeignObjectInRedlineText: true, // set foreign object in redline text to true or false

  // Tooltip text
  hambugerMenuTooltip: "Open/Close Left Panel",
  rightActionPanelTooltip: "Open Options Panel",
  leaseStartDate: "Lease Start Date",
  leaseEndDate: "Lease End Date",

  // Left Panel
  defaultLeftPanelOpen: false,

  // 1900-01-01T00:00:00 or 1900-01-01    - search of date-types for modification
  dateRegex: [
    "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}$",
    "^\\d{4}-\\d{2}-\\d{2}$",
  ],

  // Action panel side settings
  actionPanelSide: "left", // left, right,   settings of the action panel side

  // Upload files features
  maxUploadSize: "10", // maximun size in mb

  // Top Bar Logo
  topBarLogo: "", //"SNCF_reseau_01.png", // "",//"B-prop_logo_rgb.png", //"", //"SNCF_reseau_01.png" , // "SNCF Reseau    //  BPRetail "B-prop_logo_rgb.png", // "https://cadviewer.com/images/cadviewer/cv-logo.gif"
  cadViewerBrandLogoPosition: "right_center", // bottom_center right_center
  cadViewerBrandLogoSize: "small", // small large
  // Compare tool for JSON input files with structured content
  showCompareTool: true,

  enablePolygonControlPoints: true, // enable or disable polygon control points

  // HELPER SECTION - CUSTOM COMPONENTS

  // helpers components   - NOTE: add your helper components in the CADViewerHelperMthods folder structure
  enableHelperMethods: false,
  enableHelpersMethodsGroup_Highlight: true,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  helperMethodsActionSize: "small", // small, normal, large
  // add your own group of helper methods on the top toolbar

  // SECTION FOR PROPERTY MANAGEMENT

  topPaneScrollDownTitle: "Choose information plan/layer:", // set te title of the top pane scroll down menu
  displayTopPaneScrollDownButton: false, // display the top pane scroll down button, true to show the top pane scroll down menu
  topRowItem1: "Property Name:", // top row items
  topRowItem2: "Property Number:", // top row items
  topRowItem3: "Plan Name:", // top row items

  //
  customOnLoadEndContent: false, // custom OnLoadEnd content -processing of custom content in CADViewer.js
  //

  //    Global Application Files
  //   Global location for property / plans navigation:
  globalApplicationPlans: "plans.json",
  globalApplicationViews: "views.json",
  globalApplicationSearch: "search.json",

  globalApplicationFilesLocation:
    "",
  propertySVGFilesLocation:
    "",
  propertyJSONFilesLocation:
    "",

  enableRightJSONModalPanel: false, // enabling JSON load right side pane for property selection
  enableRightJSONModalPanelText: "Select Property", // test for JSON load right side pane
  enableRightJSONModalPanelText2:
    "Select a plan type, property, and floor plan to load the associated data.", // the second text line appearing on the Property Pane
  searchRightJSONModalPanelPlaceholder: "Search for property or occupant...", // the placeholder text appearing in the search field

  // quick print
  suppressPublishPDFModal: true, // the standard publishPDF modal is suppressed and replaced with QuickPDF

  enableQuickPdfPrint: true, // enabling quick pdf print
  enableQuickPdfPrintText: "Quick PDF", // test for JSON load right side pane
  enableQuickPdfPrintModalTitle: "Quick PDF Print", // the second text line appearing on the Property Pane
  enableQuickPdfPrintModalSubTitle:
    "Download a PDF with the current information plan/layer", // the second text line appearing on the Property Pane
  quickPDF_default_resolution: 600, // default resolution of quick pdf generation
  quickPDF_1_Resolution: 300, // resolution of quick pdf generation
  quickPDF_2_Resolution: 600, // resolution of quick pdf generation
  quickPDF_3_Resolution: 600, // resolution of quick pdf generation
  quickPDF_1_papersize: "letter", // resolution of quick pdf generation
  quickPDF_2_papersize: "letter", // resolution of quick pdf generation
  quickPDF_3_papersize: "tabloid", // resolution of quick pdf generation
  quickPDF_1_text: "Quick PDF", // resolution of quick pdf generation
  quickPDF_2_text: "Medium Resolution PDF", // resolution of quick pdf generation
  quickPDF_3_text: "High Resolution PDF", // resolution of quick pdf generation
  quickPDF_1_placeholder: "Standard output (letter/300dpi)", // resolution of quick pdf generation
  quickPDF_2_placeholder:
    "Increased dpi (letter/600dpi), longer processing time", // resolution of quick pdf generation
  quickPDF_3_placeholder:
    "Maximum dpi and size (tabloid/600dpi), resource demanding", // resolution of quick pdf generation
  quickPDFProcessingText: "Processing PDF, please wait...", // resolution of quick pdf generation

  // config for pdf Report in json panel
  enableJsonPDFReport: true, // enabling pdf report
  enableJsonPDFReportText: "PDF Report", // test for JSON load right side pane,
  enableJsonPDFReportModalTitle: "PDF Report", // the second text line appearing on the Property Pane
  enableJsonPDFReportModalSubTitle:
    "Download a PDF with the current information plan/layer", // the second text line appearing on the Property Pane
  jsonPDFReportPreselectFirstItemInList: true,
  jsonPDFReportSelectViewLabel: "Select View",
  jsonPDFReportSelectViewSubtitle:
    "Select the view/information plan for the report",
  jsonPDFReportSelectPlanLabel: "Select Plan",
  jsonPDFReportSelectPlanSubtitle:
    "Select one or more plans from the list below, click again to select",
  jsonPDFReportSelectResolutionLabel: "Select Resolution",
  jsonPDFReportSelectResolutionSubtitle:
    "Select the resolution for the PDF report",
  jsonPDFReport_default_resolution: 600, // default resolution of quick pdf generation
  jsonPDFReport_1_Resolution: 300, // resolution of quick pdf generation
  jsonPDFReport_2_Resolution: 600, // resolution of quick pdf generation
  jsonPDFReport_3_Resolution: 600, // resolution of quick pdf generation
  jsonPDFReport_1_papersize: "letter", // resolution of quick pdf generation
  jsonPDFReport_2_papersize: "letter", // resolution of quick pdf generation
  jsonPDFReport_3_papersize: "tabloid", // resolution of quick pdf generation
  jsonPDFReport_1_text: "Quick PDF", // resolution of quick pdf generation
  jsonPDFReport_2_text: "Medium Resolution PDF", // resolution of quick pdf generation
  jsonPDFReport_3_text: "High Resolution PDF", // resolution of quick pdf generation
  jsonPDFReport_1_placeholder: "Standard output (letter/300dpi)", // resolution of quick pdf generation
  jsonPDFReport_2_placeholder:
    "Increased dpi (letter/600dpi), longer processing time", // resolution of quick pdf generation
  jsonPDFReport_3_placeholder:
    "Maximum dpi and size (tabloid/600dpi), resource demanding", // resolution of quick pdf generation
  jsonPDFErrorSelectView: "No view selected",
  jsonPDFErrorSelectPlan: "No plan selected",
  jsonPDFErrorSelectResolution: "No resolution selected",
  jsonPDFPrintTextButton: "Download PDF",

  // CONTROL OF POPUP MODAL
  popupCustomMenu1: "Tenant Info", // custom menu 1   -  my_own_clickmenu1 in CADViewer.js
  popupCustomFontAwesomeIcon1: "fa fa-folder-open", // custom menu 1 - icon 1
  popupCustomMenu2: "Future Tenant", // custom menu 2 - my_own_clickmenu2 in CADViewer.js
  popupCustomFontAwesomeIcon2: "fa fa-folder-open", // custom menu 2  - icon 2

  settingsGoHomepageButtonText: "Go Home",

  // enable or disable space objects extraction for left drawer menu (when json it's not available)
  enableSpaceObjectsExtraction: false,
  showTourInformationDialog: true,
  enableHelpButton1: true,
  helpbutton1: "CADViewer Tech Docs",
  helpbutton1link: "https://cadviewer.com/cadviewertechdocs/",
  enableHelpButton2: true,
  helpbutton2: "CADViewer User Manual",
  helpbutton2link: "https://cadviewer.com/cadviewerusermanual/",
  customHtmlHeaderContent: `
     <!--  Update february 6th, 2023  only installed in May 29  -->
     <!-- Google tag (gtag.js) 2023-10-27 -->
     <script async src="https://www.googletagmanager.com/gtag/js?id=AW-1072657467"></script>
     <script>
       window.dataLayer = window.dataLayer || [];
       function gtag(){dataLayer.push(arguments);}
       gtag('js', new Date());
     
       gtag('config', 'AW-1072657467');
     </script>
     
     
     <!-- CRISP tag manager -->
     <script type="text/javascript"> window.$crisp=[];window.CRISP_WEBSITE_ID="50b89d34-074d-4a85-9a53-61c3705a2c51";(function(){ d=document;s=d.createElement("script"); s.src="https://client.crisp.chat/l.js"; s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})(); </script>
     
     <!--  Cookiehub 2.8.0   PRODUCTION  -->
     <script src="https://cdn.cookiehub.eu/c2/6524b042.js"></script>
     <script type="text/javascript">
     document.addEventListener("DOMContentLoaded", function(event) {
     var cpm = {};
     window.cookiehub.load(cpm);
     });
     </script>
     <script>
        function gtag_report_conversion(url) {
          const callback = function () {
            if (typeof(url) != 'undefined') {
              window.location = url;
            }
          };
          gtag('event', 'conversion', {
            'send_to': 'AW-1072657467/o15VCOOUpa0aELvovf8D',
            'value': 1.0,
            'currency': 'USD',
            'event_callback': callback
          });
          return false;
        }
     </script>
  `,
  enableGeoLocation: true,
  geolocationAPIKey: "70d6d7cb86ee89a766745277994579e77f122f1e13a4a3da81fa4150",
  recaptchaSiteKey: "6Ld8FhktAAAAAB7k9MwN6bWsYDAqwLbohbWw6yrQ",

  enableBasicAuth: false,
  basicAuthUsername: "admin",
  basicAuthPassword: "admin",

  // ===========================================================================
  // NOUVEAUX PARAMETRES AJOUTES DEPUIS feature_ai_implementation (incoming)
  // ===========================================================================

  // measurement controls
  setCallbackMeasurement: true, // set the callback measurement function

  // Floating Toolbar Configuration
  floatingToolbar: false, // display the floating toolbar
  floatingToolbarOrientation: "horizontal", // "vertical" or "horizontal"
  floatingToolbarIconSize: "medium", // "small" (w-5 h-5), "medium" (w-6 h-6), "large" (w-7 h-7)

  // helpers components - new groups
  enableHelpersMethodsGroup_VizQueryDemo: false,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,

  customOnLoadEndContentUrbanEdge: false, // custom OnLoadEnd content -processing of custom content in CADViewer.js

  // Default attributes for newly drawn Space Objects
  DefaultSpaceObjectAttributes: {
    fill: "#00f", //'#3CB043',
    "fill-opacity": "0.3", // fill opacity set to 0.3
    stroke: "#F00", // '#234F1E',
    "stroke-width": "0.6",
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },

  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,

  // Tiled Views: per-floor function/percentage overview, opened from the property card
  enableTiledViews: false, // enable the draggable Tiled Views window
  tiledViewsFilePattern: "corporate/{propertyNumber}-tiled-view.json", // {propertyNumber} resolved per property, fetched from propertyJSONFilesLocation
  tiledViewsButtonText: "Tiled View", // label of the trigger button on the property card
  tiledViewsModalTitle: "Tower Overview", // title shown in the draggable window header

  // PDF Orientation Configuration
  pdfOrientationLabel: "Orientation",
  pdfOrientationPortraitLabel: "Portrait",
  pdfOrientationLandscapeLabel: "Landscape",
  pdfDefaultOrientation: "landscape", // "portrait" | "landscape"

  // popup menu - no data set
  popupCustomMenuNoDataSet: "No Data Set Provided for this Object", // custom menu for no data set
  popupCustomMenuNoDataSetIcon: "fa fa-times", // custom menu for no data set icon

  // popup styling
  style_popup: true, // set the popup styling to true or false
  cvjs_styleQTip_color_flag: true, // set the color flag to true or false
  cvjs_styleQTip_color_v1: "#FFF",
  cvjs_styleQTip_color_v2: "#FFF",
  cvjs_styleQTip_color_v3: "#000",
  cvjs_styleQTip_color_v4: "#000",
  cvjs_styleQTip_color_v5: "#000",
  cvjs_styleQTip_fontsize_flag: true, // set the fontsize flag to true or false
  cvjs_styleQTip_fontsize_v1: "14pt",
  cvjs_styleQTip_fontsize_v2: "12pt",
  cvjs_styleQTip_fontsize_v3: "12pt",
  cvjs_styleQTip_fontsize_v4: "5px",
  cvjs_styleQTip_fontsize_v5: "11pt",
  cvjs_styleQTip_fontsize_v6: "Arial, Helvetica, sans-serif",
  cvjs_styleQTip_processbody_flag: false,
  cvjs_styleQTip_width: "400px", // set the width of the popup

  // Enable or disable the contextual menu (three dots) in ChatMessageDisplay
  enableChatMessageMenu: true, // Set to false to hide the menu in ChatMessageDisplay
  // Enable or disable each menu item in ChatMessageDisplay contextual menu
  enableMenuShowRawJson: true, // Show/hide the 'Show raw JSON' item
  enableMenuCopyRawJson: true, // Show/hide the 'Copy raw JSON' item
  enableMenuShowResults: true, // Show/hide the 'Show/Hide results' item

  // Show a "Show your work" button on AI responses to replay the persisted
  // reasoning/thinking process streamed by the snowflake-agent provider
  enableThinkingProcessReplay: true,

  // AI Response Rating
  enableAIRating: true, // Enable/disable the "Rate Answer" button on AI responses
  aiRatingEndpoint: undefined, // Defaults to conversion-server base URL + "/ai/ratings"

  // Disabled all features if not logged in
  disableAllFeaturesIfNotLoggedIn: false,

  // Default property to Load
  defautlPropertyToLoad: {
    propertyNumber: undefined, // "4279", //"2339", // set to undefined to disable default property
    planName: undefined, //"LP1", //"LP0", // set to undefined to disable default plan
  },

  // AI Chat Configuration
  enableAIChat: true, // Set to true to use the AI chat feature, v1, v2, and v3
  enableAIFieldTypes: false, // Set to true to enable the legacy field types configuration icon
  enableAIAssistantPictureInPicture: false, // Set to true to enable the Pop Out functionality for the AI Assistant
  // AI Chat V2 Configuration (using search engine)
  useAIChatV2: false, // Set to true to use the new search engine based AI chat
  // AI Chat V3 Configuration (direct server results)
  useAIChatV3: false, // Set to true to use the direct server results AI chat
  // AI Chat V4 Configuration (process-query-v3 endpoint)
  useAIChatV4: true,
  // AI Chat V5 Configuration (Snowflake proxy endpoint)
  useAIChatV5: false,
  chatResultDisplayMetrics: true, // Set to true to display metrics in the chat results
  aiChatV2Endpoint: "/ai/v2/chat", // Endpoint for the new AI chat service
  aiChatV3Endpoint: "/ai/v3/search-spaces", // Endpoint for the V3 AI chat service
  aiChatV4Endpoint: "http://localhost:8000/process-query-v4", // Endpoint for the V4 AI chat service
  aiChatV5Endpoint: "http://localhost:3000/ai/proxy", // Endpoint for the V5 proxy (supports snowflake and python)
  aiChatV5Provider: "snowflake", // "snowflake" | "python" | "snowflake-agent" | "cadviewer-analytics" - Provider for the V5 proxy endpoint
  aiChatV5Mode: "Test", // "Test" | "Prod" - Mode for the V5 proxy endpoint (defaults to "Test")
  analyticsTarget: "DEFAULT", // Target identifier sent to the cadviewer-analytics provider
  resultFieldName: ["spaceHeader", "DBA"],

  // Demo Navigation Configuration
  enableDemoNavigation: true, // Set to true to display the demo navigation buttons

  showLogoOnSideBarLeftPanel: true, // Set to true to display the logo on the side bar left panel
  enableSpaceInfoCopyButton: false, // Set to true to enable the copy button for space info
  cadViewerBrandLogoOpacity: 100, // 0 (invisible) to 100 (visible)

  // Server Sub Folder to open by default
  serverSubFolder: undefined,
  showOnlySubFolder: false,
  // Each question carries the scope it works in — clicking one switches to it.
  // Proximity and adjacency read per-plan tables, so they need the current plan;
  // portfolio-wide questions need the whole portfolio.
  aiBaseQueries: [
    { text: "I need all stores within 110 feet from Adidas", scope: "current" },
    { text: "Which tenants who are below their average square footage size over all malls by 10% or more and above their average total sales by 10% or more", scope: "global" },
    { text: "How many malls are in the portfolio and what are they called ?", scope: "global" },
    { text: "Analyze all lease plans in the portfolio and recommend a prospective tenant for Space 1485 based on the size of the space and frequent co-tenants within 200 feet of the store-front", scope: "global" },
    { text: "Provide the best options to combine adjacent spaces between 7,000 - 12,000 SF based on total rent and lease expiration", scope: "current" },
    { text: "How many stores has a future tenant and list them?", scope: "global" },
    { text: "Find adjacent vacant or expiring spaces that could be combined", scope: "current" },
  ],

  // Accordion Groups Configuration for SpaceObjectInfo panel
  // Keys are accordion section names, values are arrays of property keys to include in that section
  accordionGroups: {
    "Tenant Overview": [
      "Property #",
      "Tenant Name",
      "DBA",
      "Space Number",
      "GLA",
      "Lease Status",
      "Lease Start Date",
      "Lease End Date",
      "Total Rent",
      "Rent PSF",
      "Sales R12",
      "Kickout Clause Active",
    ],
    "Tenant & Space Info": [
      "Mall Name",
      "DBA",
      "Space #",
      "GLA",
      "Actual Footprint SF",
      "Actual Footprint M2",
      "Merchandise Category",
    ],
    "Lease Financials": [
      "BMR",
      "BMR PSF",
      "Total Rent",
      "Total Rent PSF",
      "Total Rent /M2",
      "Occupancy Cost",
      "Occupancy Cost PSF",
      "Occupancy Cost /M2",
    ],
    "Sales Performance": ["Sales R12", "Sales R12 PSF"],
    "Lease Terms": [
      "Lease ID",
      "Lease Type",
      "Lease Status",
      "Deal Type",
      "Deal ID",
      "Deal Stage",
      "Deal Record Type",
    ],
    "Important Dates": [
      "Lease Start Date",
      "Lease End Date",
      "Rent Expiration Date",
      "Executed Date",
      "ABF RCD",
      "Date of Possession (Mutually Agreed)",
      "Date of Possession (Projected Per TC)",
      "Store Opening (Projected Per TC)",
      "Date of Possession (Actual)",
      "Store Opening (Actual) Date",
    ],
    "Legal Triggers & Flags": ["Kickout Y/N"],
    "Deal Data": [
      "SF of the Deal",
      "Projected R12 Sales",
      "Projected R12 Sales PSF",
      "Deal Name",
      "Projected Rent Commencement Date",
      "Term (Months)",
      "Deal Rent Type",
    ],
    Overview: [
      "Room #",
      "Square Footage",
      "Employee",
      "Email",
      "Phone",
      "Title",
      "Employee Type Code",
      "Department",
    ],
    Others: [], // Will be populated with the rest of the keys
  },

  // Server-side Excel Room Data Configuration
  fetchRoomsDataFromServer: false, // If true, fetch rooms data from server Excel endpoint
  roomsDataEndpoint: "", // The endpoint to fetch rooms data from (e.g., "/exceldata/uic-rooms")

  // Distance Query Configuration (remote bay-to-bay distance lookup)
  enableDistanceQuery: false, // Enable/disable the distance query floating panel
  distanceQueryApiPath: "/api/distance", // Backend API base path

  // Space Tools Configuration (Space Selection & Text Manipulation)
  enableSpaceSelection: true, // Enable/disable space selection
  enableSpaceTools: true, // Enable/disable space tools (unified button for Space Selection and Text Manipulation)
  spaceToolsPosition: "bottom-right", // "bottom-right" | "bottom-left" - Position of the space tools button
  spaceSelectionPosition: "bottom-right", // Position of the space selection panel when opened
  enableQuickActions: false, // Enable/disable quick actions menu
  quickActionsConfig: {
    enableFinancialSummary: true, // Enable "Financial Summary" quick action
    enableOpportunityCost: true, // Enable "Opportunity Cost" quick action
    enableWingAnalysis: true, // Enable "Wing Analysis" quick action
    enableTenantRanking: true, // Enable "Tenant Ranking" quick action (single selection)
    enableTenantComparison: true, // Enable "Tenant Comparison" quick action (single selection)
  },

  // Field mapping used by the quick actions. Left unset here on purpose: the
  // built-in defaults (src/modules/ai/utils/analyticsSchema.ts) reproduce the
  // retail lease-plan keys this app was first built against. A customer whose
  // dataset names things differently overrides the roles they need — either in
  // their demo config or through the Cloud menu's config_overrides.
  // analyticsSchema: {
  //   tenantTabMatch: ["employee information"],
  //   areaUnitLabel: "m²",
  //   fields: { area: ["Square Footage"], tenantName: ["Employee"] },
  // },

  // Wing Analysis table shape. Unset → the retail columns (Space #, Tenant,
  // GLA, Sales PSF, Occ Cost PSF, Occ Cost %).
  // wingAnalysisConfig: { title: "Wing Analysis", columns: [...] },

  tenantInsightsProvider: "auto", // "auto" | "sql" | "planData" | "ai"

  generatedDateFormat: "YYYY-MM-DD HH:mm:ss", // Tokens: YYYY, YY, MM, DD, HH/hh, mm, ss, A/a
  use12HourTime: false,

  // Wing Analysis PDF report options
  wingPdfConfig: {
    showGeneratedDate: true, // Show the "Generated: <date>" line in the Wing Analysis PDF
    includeCoverPage: true, // Keep the report's first page (title + wing space list)
  },

  // Primary Color Palette Configuration
  // These values override the CSS defaults in index.css
  // Changing these will also affect sidebar/panel colors that derive from primary
  // https://elementor.com/tools/material-color-palette-generator/
  primaryColors: {
    50: "#e2e7eb",
    100: "#b7c2cd",
    200: "#879aab",
    300: "#577289",
    400: "#335370",
    500: "#0f3557",
    600: "#0d304f",
    700: "#0b2846",
    800: "#08223c",
    900: "#04162c",
  },

  // Theme Colors Configuration
  // Override sidebar, panel, and layout colors independently from primary palette
  // If not set, sidebar/panel colors derive from the primary palette via CSS variables
  themeColors: {
    //sidebarBackground: "#0f3557",  // defaults to var(--primary-500)
    // sidebarHamburgerBackground: "#0f3557",
    // sidebarTitle: "#f9f9f9",
    // sidebarSubtitle: "#efeff0",
    // bottomPanelBackground: "#ffffff",
    // rightActionBackground: "#0f3557",
  },

  // Button Colors Configuration
  // These values override the CSS defaults in index.css
  // You can customize button colors per-demo by setting this in demo config files
  // Or at runtime by loading from an external JSON file
  buttonColors: {
    // Primary buttons (dark blue) - used for main action buttons in the header
    primary: {
      bg: "#0d304f",
      bgHover: "#0f3557",
      text: "#ffffff",
      ring: "#0f3557",
    },
    // Accent buttons (orange gradient) - used for AI chat button
    accent: {
      bg: "#f97316",
      bgHover: "#ea580c",
      text: "#ffffff",
      gradientFrom: "#fb923c",
      gradientTo: "#c2410c",
      ring: "#f97316",
    },
    // FAB (Floating Action Buttons) - used for space tools button
    fab: {
      bg: "#0f3557",
      bgHover: "#0d304f",
      text: "#ffffff",
      ring: "#0f3557",
    },
    // Subtle/secondary buttons - used for switch plan button
    subtle: {
      bg: "#fed7aa",
      bgHover: "#fdba74",
      text: "#c2410c",
    },
  },
  omitSpaceObjectLayerHandling: false,
};
export default config;